module.exports = __webpack_public_path__ + "img/edu-road-3.c90fcbd5.png";